/************
 * Service Class
 * File Name ...: agencies.service.ts
 * Generated By : ianday on 10/10/23
 * Date ........: 10/10/23
 /************/
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {retry, catchError} from 'rxjs/operators';
import {Agencies} from '../models/agencies';
import {Settings} from './settings';

@Injectable({
    providedIn: 'root'
})
export class AgenciesService {

    constructor(private http: HttpClient) {
    }

    public getAllAgencies(): Observable<any> {
        return this.http.get<any>(Settings.getInstance().BASE_URL + 'agencies/agencies')
            .pipe(
                retry(1)
            );
    }
    public getAllAgenciesOrderByName(): Observable<any> {
        return this.http.get<any>(Settings.getInstance().BASE_URL + 'agencies/agencies/ordered')
            .pipe(
                retry(1)
            );
    }
    public getAllAgenciesByForeignKey(fkTable: string, fkId: number): Observable<any> {
        return this.http.get<any>(Settings.getInstance().BASE_URL + 'agencies/agencies' + '/' + fkTable + '/' + fkId)
            .pipe(
                retry(1)
            );
    }
    public getAgencyById(id: number): Observable<any> {
        return this.http.get<any>(Settings.getInstance().BASE_URL + 'agencies/agencies' + '/' + id)
            .pipe(
                retry(1)
            );
    }

    public createAgencies(record: Agencies): Observable<any> {
        return this.http.post(Settings.getInstance().BASE_URL + 'agencies/agencies', record)
            .pipe(
                retry(1)
            );
    }

    public updateAgencies(record: Agencies): Observable<any> {
        return this.http.put(Settings.getInstance().BASE_URL + 'agencies/agencies/' + record.id, record)
            .pipe(
                retry(1)
            );
    }

    public deleteAgencies(id: number): Observable<any> {
        return this.http.delete(Settings.getInstance().BASE_URL + 'agencies/agencies/' + id)
            .pipe(
                retry(1)
            );
    }
    public getQualifyingAgencies(serviceTypeId: number, zipCode: string): Observable<any> {
        return this.http.get<any>(Settings.getInstance().BASE_URL + 'agencies/agencies/service-type/'+ serviceTypeId + '/'+ zipCode)
            .pipe(
                retry(1)
            );
    }
    public getQualifyingAgenciesForCollaboration(serviceRequestId: number, serviceTypeId: number, zipCode: string): Observable<any> {
        return this.http.get<any>(Settings.getInstance().BASE_URL + 'agencies/agencies/service-type/collaboration/'+ serviceRequestId + '/'+ serviceTypeId +'/'+ zipCode)
            .pipe(
                retry(1)
            );
    }
}
